// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 팝아웃 오버레이 */
.detach-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 5000;
}

/* 팝아웃 윈도우 */
.detach-window {
  position: fixed;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  z-index: 5001;
  overflow: hidden;
  min-width: 400px;
  min-height: 300px;
}

/* 타이틀바 */
.detach-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #f0f2f5;
  border-bottom: 1px solid #ddd;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}
.detach-titlebar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.detach-titlebar-btns {
  display: flex;
  gap: 4px;
}
.detach-titlebar-btn {
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  padding: 3px 6px;
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
}
.detach-titlebar-btn:hover {
  background: #e0e0e0;
  color: #333;
}

/* 콘텐츠 */
.detach-content {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* 리사이즈 핸들 */
.detach-resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  cursor: nwse-resize;
  opacity: 0.3;
}
.detach-resize-handle:hover {
  opacity: 0.7;
}
.detach-resize-handle::after {
  content: '';
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 8px;
  height: 8px;
  border-right: 2px solid #999;
  border-bottom: 2px solid #999;
}

/* 인라인 분리 버튼 (에디터/결과 영역에 표시) */
.detach-inline-btn {
  background: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  padding: 4px 5px;
  line-height: 1; /* 줄 상자를 글자 높이에 맞춰 레이블이 아래로 치우치지 않게 — 줄인 만큼 위아래 여백을 늘려 높이는 그대로 */
  font-size: 12px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 3px;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;       /* 버튼 내부 레이블(창분리/수직분할 등)은 줄바꿈 금지 */
  flex-shrink: 0;            /* 공간 부족 시 다른 요소가 먼저 줄어들도록 */
}

/* 분리/수직분할 버튼 영역 하단 구분선 */
.detach-toolbar {
  border-bottom: 1px solid var(--color-border, #e0e0e0);
}
.detach-inline-btn:hover {
  color: #007bff;
  border-color: #007bff;
}

/* 분리됨 결합 바 */
.detach-rejoin-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  background: #e8f0fe;
  border: 1px dashed #4a90d9;
  border-radius: 4px;
  margin: 2px 0;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.detach-rejoin-bar:hover {
  background: #d0e2fd;
}

/* 다크모드 */
[data-theme="dark"] .detach-inline-btn {
  color: var(--color-text-secondary) !important;
  border-color: var(--color-border) !important;
}
/* 호버는 파랑이 아니라 한 단계 밝은 배경 + 회색 테두리(2026-09-13). 파랑은 켜짐(.active)에만 쓴다 */
[data-theme="dark"] .detach-inline-btn:hover {
  color: var(--color-text) !important;
  border-color: var(--color-hover-border, #5a5a5a) !important;
  background: var(--color-hover);
}
[data-theme="dark"] .editor-search-bar {
  background: var(--color-bg-tertiary) !important;
  border-color: var(--color-border) !important;
}
[data-theme="dark"] .editor-search-input {
  color: var(--color-text) !important;
  background: transparent !important;
}
[data-theme="dark"] .editor-search-nav {
  color: var(--color-text-secondary) !important;
}
[data-theme="dark"] .editor-search-nav:hover {
  background: var(--color-hover) !important;
  color: var(--color-text) !important;
}
[data-theme="dark"] .editor-option-label {
  color: var(--color-text-secondary) !important;
}
[data-theme="dark"] .detach-rejoin-bar {
  background: #1a3a5c !important;
  border-color: #264f78 !important;
  color: #6cb6ff !important;
}
[data-theme="dark"] .detach-placeholder {
  background: var(--color-bg-secondary) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-muted) !important;
}

/* 에디터 옵션 체크박스 */
.editor-option-label {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: var(--color-text-secondary, #666);
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.editor-option-label input[type="checkbox"] {
  margin: 0;
  width: 12px;
  height: 12px;
  cursor: pointer;
  accent-color: #3b82f6;
}
[data-theme="dark"] .editor-option-label input[type="checkbox"] {
  color-scheme: dark;
  accent-color: #6cb6ff;
}

/* 에디터 검색바 */
.editor-search-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f0f4f8;
  border: 1px solid #d0d8e0;
  border-radius: 4px;
  padding: 2px 6px;
}
.editor-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 12px;
  width: 160px;
  padding: 2px 4px;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
}
.editor-search-count {
  font-size: 10px;
  color: #888;
  white-space: nowrap;
  min-width: 28px;
  text-align: center;
}
.editor-search-nav {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #666;
  display: flex;
  align-items: center;
  border-radius: 2px;
}
.editor-search-nav:hover {
  background: #dde4ec;
  color: #333;
}

/* 접힌 영역 플레이스홀더 */
.detach-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: #999;
  font-size: 13px;
  background: #f9f9f9;
  border: 1px dashed #ddd;
  border-radius: 4px;
  gap: 8px;
  cursor: pointer;
}
.detach-placeholder:hover {
  border-color: #007bff;
  color: #007bff;
}

/* 눌림 상태 — 화면 구성이 바뀌는 모드·패널 버튼(수직 분할·데이터 분석·AI 에이전트)을 한 모양으로.
   예전엔 인라인 style 로 색만 바꿔 버튼마다 달랐고(분할은 표시조차 없었다) 다크모드에서 조정할 수 없었다.
   결과 접기(.split-collapse-btn.active)와 같은 톤. */
.detach-inline-btn {
  transition: color 0.15s, border-color 0.15s, background-color 0.15s;
}
.detach-inline-btn.active {
  color: #1d4ed8;
  border-color: rgba(29, 78, 216, 0.5);
  background: rgba(59, 130, 246, 0.12);
}
[data-theme="dark"] .detach-inline-btn.active {
  color: #6cb6ff !important;
  border-color: rgba(108, 182, 255, 0.55) !important;
  background: rgba(108, 182, 255, 0.14);
}
@media (prefers-reduced-motion: reduce) {
  .detach-inline-btn { transition: none; }
}

`, "",{"version":3,"sources":["webpack://./src/components/DetachablePanel.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,gEAAgE;EAChF,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB,QAAQ,kCAAkC;EAC7D,cAAc,aAAa,4BAA4B;AACzD;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;AACA,sEAAsE;AACtE;EACE,mCAAmC;EACnC,2DAA2D;EAC3D,8BAA8B;AAChC;AACA;EACE,+CAA+C;EAC/C,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;6CAE6C;AAC7C;EACE,mEAAmE;AACrE;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,qCAAqC;AACvC;AACA;EACE,qBAAqB,gBAAgB,EAAE;AACzC","sourcesContent":["/* 팝아웃 오버레이 */\r\n.detach-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0,0,0,0.3);\r\n  z-index: 5000;\r\n}\r\n\r\n/* 팝아웃 윈도우 */\r\n.detach-window {\r\n  position: fixed;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 40px rgba(0,0,0,0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  z-index: 5001;\r\n  overflow: hidden;\r\n  min-width: 400px;\r\n  min-height: 300px;\r\n}\r\n\r\n/* 타이틀바 */\r\n.detach-titlebar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 6px 12px;\r\n  background: #f0f2f5;\r\n  border-bottom: 1px solid #ddd;\r\n  cursor: move;\r\n  user-select: none;\r\n  flex-shrink: 0;\r\n}\r\n.detach-titlebar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n.detach-titlebar-btns {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n.detach-titlebar-btn {\r\n  background: none;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  padding: 3px 6px;\r\n  font-size: 14px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.detach-titlebar-btn:hover {\r\n  background: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n/* 콘텐츠 */\r\n.detach-content {\r\n  flex: 1;\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* 리사이즈 핸들 */\r\n.detach-resize-handle {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: nwse-resize;\r\n  opacity: 0.3;\r\n}\r\n.detach-resize-handle:hover {\r\n  opacity: 0.7;\r\n}\r\n.detach-resize-handle::after {\r\n  content: '';\r\n  position: absolute;\r\n  right: 3px;\r\n  bottom: 3px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-right: 2px solid #999;\r\n  border-bottom: 2px solid #999;\r\n}\r\n\r\n/* 인라인 분리 버튼 (에디터/결과 영역에 표시) */\r\n.detach-inline-btn {\r\n  background: none;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  padding: 4px 5px;\r\n  line-height: 1; /* 줄 상자를 글자 높이에 맞춰 레이블이 아래로 치우치지 않게 — 줄인 만큼 위아래 여백을 늘려 높이는 그대로 */\r\n  font-size: 12px;\r\n  color: #888;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  transition: color 0.15s, border-color 0.15s;\r\n  white-space: nowrap;       /* 버튼 내부 레이블(창분리/수직분할 등)은 줄바꿈 금지 */\r\n  flex-shrink: 0;            /* 공간 부족 시 다른 요소가 먼저 줄어들도록 */\r\n}\r\n\r\n/* 분리/수직분할 버튼 영역 하단 구분선 */\r\n.detach-toolbar {\r\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n}\r\n.detach-inline-btn:hover {\r\n  color: #007bff;\r\n  border-color: #007bff;\r\n}\r\n\r\n/* 분리됨 결합 바 */\r\n.detach-rejoin-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  background: #e8f0fe;\r\n  border: 1px dashed #4a90d9;\r\n  border-radius: 4px;\r\n  margin: 2px 0;\r\n  color: #2563eb;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: background 0.15s;\r\n}\r\n.detach-rejoin-bar:hover {\r\n  background: #d0e2fd;\r\n}\r\n\r\n/* 다크모드 */\r\n[data-theme=\"dark\"] .detach-inline-btn {\r\n  color: var(--color-text-secondary) !important;\r\n  border-color: var(--color-border) !important;\r\n}\r\n/* 호버는 파랑이 아니라 한 단계 밝은 배경 + 회색 테두리(2026-09-13). 파랑은 켜짐(.active)에만 쓴다 */\r\n[data-theme=\"dark\"] .detach-inline-btn:hover {\r\n  color: var(--color-text) !important;\r\n  border-color: var(--color-hover-border, #5a5a5a) !important;\r\n  background: var(--color-hover);\r\n}\r\n[data-theme=\"dark\"] .editor-search-bar {\r\n  background: var(--color-bg-tertiary) !important;\r\n  border-color: var(--color-border) !important;\r\n}\r\n[data-theme=\"dark\"] .editor-search-input {\r\n  color: var(--color-text) !important;\r\n  background: transparent !important;\r\n}\r\n[data-theme=\"dark\"] .editor-search-nav {\r\n  color: var(--color-text-secondary) !important;\r\n}\r\n[data-theme=\"dark\"] .editor-search-nav:hover {\r\n  background: var(--color-hover) !important;\r\n  color: var(--color-text) !important;\r\n}\r\n[data-theme=\"dark\"] .editor-option-label {\r\n  color: var(--color-text-secondary) !important;\r\n}\r\n[data-theme=\"dark\"] .detach-rejoin-bar {\r\n  background: #1a3a5c !important;\r\n  border-color: #264f78 !important;\r\n  color: #6cb6ff !important;\r\n}\r\n[data-theme=\"dark\"] .detach-placeholder {\r\n  background: var(--color-bg-secondary) !important;\r\n  border-color: var(--color-border) !important;\r\n  color: var(--color-text-muted) !important;\r\n}\r\n\r\n/* 에디터 옵션 체크박스 */\r\n.editor-option-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  font-size: 11px;\r\n  color: var(--color-text-secondary, #666);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  user-select: none;\r\n}\r\n.editor-option-label input[type=\"checkbox\"] {\r\n  margin: 0;\r\n  width: 12px;\r\n  height: 12px;\r\n  cursor: pointer;\r\n  accent-color: #3b82f6;\r\n}\r\n[data-theme=\"dark\"] .editor-option-label input[type=\"checkbox\"] {\r\n  color-scheme: dark;\r\n  accent-color: #6cb6ff;\r\n}\r\n\r\n/* 에디터 검색바 */\r\n.editor-search-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  background: #f0f4f8;\r\n  border: 1px solid #d0d8e0;\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n}\r\n.editor-search-input {\r\n  border: none;\r\n  background: transparent;\r\n  outline: none;\r\n  font-size: 12px;\r\n  width: 160px;\r\n  padding: 2px 4px;\r\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n}\r\n.editor-search-count {\r\n  font-size: 10px;\r\n  color: #888;\r\n  white-space: nowrap;\r\n  min-width: 28px;\r\n  text-align: center;\r\n}\r\n.editor-search-nav {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 2px;\r\n}\r\n.editor-search-nav:hover {\r\n  background: #dde4ec;\r\n  color: #333;\r\n}\r\n\r\n/* 접힌 영역 플레이스홀더 */\r\n.detach-placeholder {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px;\r\n  color: #999;\r\n  font-size: 13px;\r\n  background: #f9f9f9;\r\n  border: 1px dashed #ddd;\r\n  border-radius: 4px;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n}\r\n.detach-placeholder:hover {\r\n  border-color: #007bff;\r\n  color: #007bff;\r\n}\r\n\r\n/* 눌림 상태 — 화면 구성이 바뀌는 모드·패널 버튼(수직 분할·데이터 분석·AI 에이전트)을 한 모양으로.\r\n   예전엔 인라인 style 로 색만 바꿔 버튼마다 달랐고(분할은 표시조차 없었다) 다크모드에서 조정할 수 없었다.\r\n   결과 접기(.split-collapse-btn.active)와 같은 톤. */\r\n.detach-inline-btn {\r\n  transition: color 0.15s, border-color 0.15s, background-color 0.15s;\r\n}\r\n.detach-inline-btn.active {\r\n  color: #1d4ed8;\r\n  border-color: rgba(29, 78, 216, 0.5);\r\n  background: rgba(59, 130, 246, 0.12);\r\n}\r\n[data-theme=\"dark\"] .detach-inline-btn.active {\r\n  color: #6cb6ff !important;\r\n  border-color: rgba(108, 182, 255, 0.55) !important;\r\n  background: rgba(108, 182, 255, 0.14);\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .detach-inline-btn { transition: none; }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
